angular.module( 'acme.view.application.settings.integration.sync', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.settings.integration.sync.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var settingsIntegrationSync = {
        name: 'application.settings.integration.sync',
        url: '/sync',
        views: {
          "subview-main": {
            controller: 'SettingsIntegrationSyncController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/settings/integration/sync/sync.tpl.html'
          }
        },
        data: {
          pageTitle: 'Salesforce Integration'
        },
        resolve: {
          TenantData: ['ApiService', function(ApiService) {
            return ApiService.tenant.view();
          }]
        }
      };

    $stateProvider
      .state(settingsIntegrationSync);
});
